import React from "react"
import {AlertTriangle} from "react-feather"
import FlexBox from "@/components/layout/FlexBox"
import Button from "@/components/Button"
import {useTheme} from "@/hooks/useTheme"

const getStyles = (theme) => ({
  container: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 9999,
    backgroundColor: `${theme.brand.primary}`,
    borderBottom: `3px solid ${theme.brand.primary}`,
    padding: "10px",
  },
  content: {
    maxWidth: "420px",
    margin: "0 auto",
    width: "100%"
  },
  iconContainer: {
    marginRight: 10,
    flexShrink: 0
  },
  messageContainer: {
    flex: 1,
    marginRight: 12
  },
  title: {
    fontSize: 14,
    fontWeight: 800,
    color: theme.brand.secondary,
    marginBottom: 4
  },
  message: {
    fontSize: 12,
    fontWeight: 600,
    color: theme.brand.secondary,
  },
  buttonContainer: {
    flexShrink: 0
  }
})

export const VersionMismatchBanner = ({onReload}) => {
  const theme = useTheme()
  const styles = getStyles(theme)

  return (
    <div style={styles.container}>
      <FlexBox style={styles.content} row vCenter>
        <FlexBox style={styles.iconContainer}>
          <AlertTriangle
            size={24}
            color={theme.backgroundColor1}
            strokeWidth={2}
          />
        </FlexBox>
        <FlexBox column style={styles.messageContainer}>
          <div style={styles.title}>Update Available</div>
          <div style={styles.message}>
            A new version of this application is available. Please reload to continue.
          </div>
        </FlexBox>
        <FlexBox style={styles.buttonContainer}>
          <Button
            text="Reload Now"
            onClick={onReload}
            style={{
              backgroundColor: theme.brand.primary,
              border: `3px solid ${theme.brand.secondary}`,
              color: theme.brand.secondary,
              fontSize: 12,
              padding: "8px 16px",
              whiteSpace: "nowrap"
            }}
          />
        </FlexBox>
      </FlexBox>
    </div>
  )
}
